export default {
  login: {
    loginTitle: 'Logowanie',
    emailInfo:
      'Jeśli chcesz uzyskać prowizję za wrzucone zdjęcia, podaj adres e-mail powiązany z kontem paypal',
    email: 'Email',
    phoneNumberInfo: 'Aby móc wypłacać pieniądze, podaj swój numer telefonu.',
    phoneNumber: 'Numer telefonu',
    password: 'Hasło',
    repassword: 'Powtórz hasło',
    forgotPassword: 'Nie pamiętasz hasła?',
    loginButton: 'Zaloguj się',
    loginNotify: 'Zalogowano!',
    register: 'Rejestracja',
    username: 'Nazwa użytkownika',
    registration: 'Zarejestruj Się',
    createAccount: 'Załóż konto',
    referal: 'Dodaj polecenie',
    referalTitle: 'Dodaj polecającego biegacza',
    referalDesc:
      '(opcjonalne) Możesz podać numer znajomego biegacza - jeśli wszyscy jego znajomi dodadzą co najmniej 50 zdjęć innych osób, dostanie 30% zniżki!',
    runnerNumber: 'Numer biegacza',
    accountType: 'Typ konta',
    supporter: 'Kibic',
    photographer: 'Fotograf',
    portfolioTitle:
      'Jestem profesjonalnym fotografem, chcę otrzymywać wynagrodzenie za swoje zdjęcia. Zgłaszam się do weryfikacji - Link do mojego portfolio:',
    portfolio: 'Portfolio',
  },
  recoverPassword: {
    recoverDescription:
      'Proszę wpisać adres e-mail użyty podczas rejestracji konta, wyślemy Ci link do odzyskania hasła',
    recoverButton: 'Odzyskaj hasło',
    recoverGoBack: 'Ukryj odzyskiwanie hasła',
    recoverSuccess:
      'Jeśli podany adres e-mail jest powiązany z kontem w naszym systemie, wysłaliśmy wiadomość z instrukcją resetowania hasła. Jeżeli nie otrzymasz wiadomości w ciągu kilku minut, sprawdź folder SPAM lub spróbuj ponownie.',
    recoverError: 'Wystąpił błąd podczas wysyłania linku do odzyskania hasła',
    title: 'Ustaw nowe hasło',
    resetButton: 'Zmień hasło',
    repeat: 'Powtórz hasło',
    resetInfo: 'Wymagania bezpieczeństwa hasła:',
    requirements1: 'min 8 znaków',
    requirements2: 'min 1 duża litera',
    requirements3: 'min 1 mała litera',
    requirements4: 'min 1 cyfra',
    resetSuccess: 'Hasło zmienione! Można się zalogować ponownie.',
    invalidEmail: 'Niepoprawny email',
    invalidKey:
      'Klucz odzyskania hasła wygasł. Poproś o nowy email resetujący.',
    validation: 'Wymogi bezpieczeństwa hasła niespełnione.',
  },
  validation: {
    required: 'Pole jest obowiązkowe',
    minValue: 'Minimalna ilość znaków 3',
    email: 'Wpisz poprawny email',
    countryRequired: 'Wybierz kraj',
    phoneNumber: 'Wpisz poprawny numer telefonu',
    samePassword: 'Hasła powinne być identyczne',
    completeAllFields: 'Uzupełnij wszystkie dane',
    accountType: 'Typ konta jest nieprawidłowy',
    portfolio: 'Adres URL portfolio jest nieprawidłowy',
    minPrice: "Cena musi wynosić co najmniej {min} zł",
    postcode: 'Nieprawidłowy format kodu pocztowego, musi mieć 1-6 znaków',
    language: 'Wybierz język',
    bankAccountIban: 'IBAN musi być poprawny i mieć między 15-34 znaków',
    bankAccountCurrency: 'Wybierz walutę twojego konta bankowego',
    invalidFormat: 'Zły format dozwolone znaki: cyfry, litery oraz "." and "_"'
  },
  duplicates: {
    general:
      'Twoje ostatnie zdjęcia, które przesłałeś, są duplikatami zdjęć, które już istnieją w systemie. Następujące biegi zawierają duplikaty:',
    unknownEvent: 'Nieznane wydarzenie',
    acceptSuccess: 'Duplikaty zostały usunięte',
    acceptError: 'Wystąpił błąd podczas usuwania duplikatów',
  },
  navigation: {
    home: 'Glówna',
    addPhoto: 'Dodaj zdjęcie',
    addVideo: 'Dodaj wideo',
    walletProfile: 'Portfel',
    myEvents: 'Moje wydarzenia',
    bookings: 'Zlecenia',
    logout: 'Wyloguj się',
    profile: 'Twój profil',
    signAs: 'Zalogowany jako',
    signIn: 'Załoguj się',
    role: 'Rola',
  },
  events: {
    eventsDescription:
      'Lista wydarzeń w których uczestniczysz, naciśnij przycisk aby przejść do panelu informacyjnego wydarzenia',
    eventsDescription2: "Po wypełnieniu formularza dodawania, wydarzenie zostanie wysłane do weryfikacji administratora w celu werfyikacji. Po pomyślnej weryfikacji, będzie ono wyświetlone w zakładce \"zweryfikowane\"",
    eventStart: 'Data wydarzenia',
    albumsQty: 'Albumy',
    button: 'Przejdź do wydarzenia',
    loading: 'Ładowanie Twoich wydarzeń...',
    noEventsMessage: 'Nie masz żadnych wydarzeń',
    noOtherEvents: 'Brak innych wydarzeń',
    eventStatus: 'Status wydarzenia',
    verified: 'Zweryfikowane',
    unverified: 'Nie zweryfikowane',
    addEvent: 'Dodaj wydarzenie',
    editEvent: 'Edycja wydarzenia',
    deleteBtn: 'Usuń wydarzenie',
    deleted: 'Szkic wydarzenia usunięty',
    sponsorPhoto: {
      description: 'Ustawienia globalnego zdjęcia sponsorskiego. Zostanie ono użyte do nakładek na zdjęcia sponsorskie w biegach w których jesteś przypisany jako sponsor.',
      info: 'Możesz również zmienić zdjęcie sponsorskie wyłącznie dla wybranego biegu przyciskając przycisk edycji w biegu poniżej.',
      eventImageField: 'Obraz sponsorski wydarzenia (maks. 5mb)',
      globalImageField: 'Globalny obraz sponsorski (maks. 5mb)',
      modalInfo: 'Zmień zdjęcie sponsorskie tego wydarzenia, zostanie ono użyte do nałożenia nakładki sponsorskiej na zdjęcia w wydarzeniu.',
      modalWarning: 'Zmiana możliwa jest wyłącznie przed rozpoczęciem wydarzenia.',
      formError: 'Wystąpił błąd podczas aktualizacji zdjęcia sponsorskiego.',
      formSuccess: 'Pomyślnie zaktualizowano zdjęcie sponsorskie.',
      eventSponsorPhotoInfo: 'Dodaj zdjęcie sponsorskie do użycia jako nakładka do zdjęc w tym wydarzeniu',
      noGlobalImage: 'Brak domyślnego zdjęcia sponsora',
    },
    sponsorAssets: {
      title: 'Materiały sponsorskie',
      description: 'Zarządzaj materiałami sponsorskimi dla tego wydarzenia. Tutaj możesz dodawać pliki, które będą powiązane z Twoim sponsoringiem.',
      uploadLabel: 'Wybierz plik',
      assetName: 'Nazwa pliku (max 18 znaków)',
      uploadRestrictedDate: 'Dodawanie plików możliwe tylko do dnia rozpoczęcia wydarzenia.',
      duplicate: 'Ten plik został już dodany',
      noAssets: 'Nie dodano jeszcze żadnych materiałów.',
      button: 'Marki',
      eventsTitle: 'Wydarzenia sponsorowane',
      eventsDescription: 'Poniżej znajduje się lista wydarzeń, których jesteś sponsorem. Możesz zarządzać swoimi materiałami dla każdego wydarzenia.',
    },
    form: {
      eventTitle: 'Nazwa wydarzenia',
      photoPrice: 'Cena pojedyńczego zdjęcia (zł)',
      albumPrice: 'Cena albumu (zł)',
      image: 'Obraz podstrony wydarzenia (maks. 5mb)',
      submit: 'Wyślij do weryfikacji',
      authorsCommission: 'Prowizja dla autorów zdjęc profesjonalnych (%)',
      hasBib: 'Uczestniczy mają numer identyfikacyjny',
      hasBibDescription: "Zaznaczając powyższe potwierdzam, że uczestnicy mają numery startowe (na koszulce, albo na zawieszonej na ubraniu tablicy itp.)",
      faceRecognitionInfo: "(Funkcjonalność rozpoznawania twarzy tymczasowo wyłączona ze względu na regulacje prawne, obecne regulacje Europejskie nie pozwalają na jej udostępnienie)",
      error:
        'Błąd przy tworzeniu wydarzenia, sprawdź wszystkie pola w forumalrzu.',
      success: 'Wydarzenie utworzone pomyślnie!',
      fileFormat: 'Zły format. Dozwolone jpeg, jpg, png',
      fileSize: 'Obraz jest za duży, maksymalnie 5mb',
      upload: 'Błąd przy dodawaniu zdjęcia, wybierz inny obraz.',
      update: 'Zaktualizuj',
      updateSuccess: 'Wydarzenie zakutalizowane pomyślnie!',
      fetchError: 'Błąd przy pobieraniu danych wydarzenia, spróbuj ponownie.',
    },
    error: {
      notFound: 'Nie znaleziono wydarzenia',
      update: 'Błąd w trakcie edycji wydarzenia. Spróbuj ponownie. ',
      add: 'Bład przy dodawaniu wydarzenia. Spróbuj ponownie',
    },
    photographer: {
      myEvents: "Prywatne wydarzenia",
      eventsDescription: "Lista Twoich prywatnych wydarzeń, dostępna tylko poprzez stronę Twojego portfolio lub za pomocą bezpośredniego linku, który możesz udostępnić.",
      eventsDescription3: "Uzupełnij formularz poprawnymi danymi, po weryfikacji administratora, nie możliwa jest zmiana informacji dotyczących wydarzenia."
    },
    organizer: {

    },
    verifiedTab: 'Zweryfikowane',
    unverifiedTab: 'Oczekujące na weryfikację',
    eventSettings: 'Ustawienia wydarzeń',
    noActiveEvents: 'Brak aktywnych wydarzeń',
    goToAlbum: 'Idź do albumu',
    goToLanding: 'Idź do portfolio',
    location: 'Lokacja',
    editTooltip: 'Edytuj',
    deleteTooltip: 'Usuń',
    locationInVerification: 'W trakcie weryfikacji'
  },
  dashboard: {
    menu: {
      shares: 'Udostępnienia',
      totalOrders: 'Zamówienia',
      backBtn: 'Wróć do wydarzeń',
      stats: 'Statystyki',
      addPhoto: 'Dodaj zdjęcia',
      prefillForm: 'Formularz został uzupełniony danymi wydarzenia',
      showMore: 'Pokaż więcej',
      showLess: 'Schowaj',
      currencyBtn: 'Wybierz walutę',
      currencyInfo: 'Dane dla waluty',
    },
    main: {
      salesReport: 'Raport sprzedaży',
      earnedCommision: 'Zarobiona prowizja',
      comissionPayout: 'Dostępne do wypłaty',
      withdraw: 'Wypłać',
      albumViews: 'Wyświetlenia albumów',
      eventViews: 'Wyświetlenia wydarzenia',
      albumPhotos: 'Zdjęcia w wydarzeniu',
      photosSold: 'Kupione zdjęcia',
      startDate: 'Data wydarzenia',
      totalOrders: 'Liczba transakcji',
      totalAlbumSalesAmount: 'Suma sprzedaży',
      socialMediaSharesCount: 'Udostępnień',
      totalCommissionEarned: 'Zarobiona prowizja',
      totalCommissionPaid: 'Wypłacona prowizja',
      amountToBePaid: 'Pozostało do wypłaty',
      totalAlbumViews: 'Wyświetleń albumów',
      totalPhotosInEvent: 'Zdjęć w wydarzeniu',
      totalAlbumsSold: 'Sprzedanych albumów',
      totalPhotosSold: 'Sprzedanych pojedyńczo zdjęć',
      loading: 'Ładowanie danych wydarzenia...',
    },
    ordersTable: {
      title: 'Zamówienia',
      orderId: 'ID zamówienia',
      orderDate: 'Data',
      albumLink: 'Link do albumu',
      orderAmount: 'Kwota',
      coupon: 'Kupon',
      currency: 'Waluta',
      authorCommission: 'Prowizja autora',
      paygateCommission: 'Prowizja bramki',
      afterFeesTotal: 'Zysk organizatora',
      noOrders: 'Brak zamówień dla tego wydarzenia.',
      sumCommissions: 'Suma prowizji organizatora',
    },
    sponsorAssetsTable: {
      title: 'Statystyki materiałów sponsorskich',
      totalDetections: 'Wszystkie detekcje na zdjęciach',
      totalEventPhotos: 'Liczba wszystkich zdjęć',
      totalSponsoredPhotos: 'Zdjęcia z Twoją marką',
      exposureRatio: 'Współczynnik ekspozycji',
      assetName: 'Nazwa pliku',
      detectionsCount: 'Liczba detekcji',
      image: 'Podgląd',
      noData: 'Brak detekcji',
    },
    sharesTable: {
      title: 'Tabela udostępnień',
      shareId: 'ID',
      link: 'Link',
      copy: 'Kopiuj',
      linkCopySuccess: 'Link skopiowany do schowka!',
      linkCopyFail: 'Nie udało się skopiować linku',
      noData: 'Brak udostępnionych albumów',
      product: 'Produkt',
    },
    albumViewsTable: {
      title: 'Tabela wyświetleń albumów',
      noData: 'Brak dostępnych albumów',
      albumNumber: 'Numer Biegacza/Albumu',
      views: 'Ilość wyświetleń',
      filterAlbums: 'Wyszukaj wyświetlenia dla numeru albumu...'
    },
    charts: {
      day: 'Ostatnie 24h',
      week: 'Ostatnie 7 dni',
      month: 'Ostatnie 30 dni',
      total: 'Wszystkie',
      timeFrame: 'Zakres danych',
      weekLabel: 'Tydzień',
    },
  },
  role: {
    photographer: 'Fotograf',
    supporter: 'Kibic',
    organizer: 'Organizator',
    sponsor: 'Sponsor',
    photographer_verification: 'Fotograf (weryfikacja)',
    agent: 'Agent',
  },
  addMedia: {
    addPhotoTitle: 'Dodaj zdjęcia',
    addVideoTitle: 'Dodaj filmy',
    addFiles: 'Dodaj pliki',
    blockedText: 'Aby dodać zdjęcia zaloguj się',
    subHeaderTitle: 'RunPixie - Odnajdź siebie!',
    resume: {
      detectedMessage: 'Wykryto niedokończone wysyłanie: {confirmed} z {total} zdjęć jest już potwierdzonych.',
      reselectMessage: 'Aby wznowić wysyłanie, wybierz ponownie te same pliki lub folder. Pozostało {remaining} z {total} zdjęć.',
      resume: 'Wznów wysyłanie',
      resumeSelected: 'Wznów z wybranych plików',
      resumeSelectedPrimary: 'Wznów wysyłanie ({count})',
      selectRemainingPrimary: 'Wybierz pozostałe zdjęcia ({count})',
      selectedReadyMessage: 'Do wysłania zostało {remaining} z {total} zdjęć. Są już wybrane poniżej — możesz od razu wznowić wysyłanie.',
      discard: 'Odrzuć zapis sesji',
      chooseFolder: 'Wybierz folder (z możliwością wznowienia)',
      reselectInstruction: 'Wybierz ponownie te same pliki lub folder, a następnie kliknij „Wznów z wybranych plików”. Już potwierdzone zdjęcia zostaną pominięte.',
      filesMismatch: 'Dopasowano {matched} z {required} niewysłanych plików. Wybierz pełny zestaw pozostałych zdjęć.',
      noSupportedFiles: 'W wybranym folderze nie znaleziono obsługiwanych zdjęć.',
      folderError: 'Nie udało się odczytać wybranego folderu.',
    },
    guide: {
      title: 'Bezpieczne wysyłanie zdjęć',
      intro: 'Duże wysyłki możesz bezpiecznie wstrzymać, wznowić lub dokończyć później.',
      tabs: {
        how: 'Jak to działa',
        faq: 'Co jeśli…?',
      },
      resumeAfterRefresh: 'Jeśli przypadkowo odświeżysz lub zamkniesz stronę, po powrocie pomożemy Ci wznowić wysyłanie bez zaczynania od początku.',
      pause: '„Wstrzymaj” zatrzymuje rozpoczynanie kolejnych wysyłek. Aktualnie trwające paczki mogą się jeszcze bezpiecznie zakończyć.',
      resumeLater: '„Wznowię później” zapisuje postęp i pozostawia do wysłania tylko zdjęcia, których system jeszcze nie potwierdził.',
      autoRetry: 'Przy chwilowym problemie z internetem lub serwerem system automatycznie ponawia wysyłanie.',
      keepFiles: 'Nie usuwaj ani nie przenoś zdjęć z komputera, dopóki cały upload nie zostanie zakończony.',
      gotIt: 'Rozumiem',
      open: 'Jak działa bezpieczne wysyłanie?',
      largeUploadNotice: 'Wybrano {count} zdjęć. Możesz wysyłać duży zestaw bez pilnowania każdego pliku; postęp jest zapisywany i może zostać wznowiony.',
      pausedNotice: 'Wysyłanie zostało wstrzymane. Trwające paczki mogą się jeszcze bezpiecznie zakończyć.',
      continuedNotice: 'Wysyłanie zostało wznowione.',
      savedLaterNotice: 'Postęp został zapisany. Potwierdzono {confirmed} z {total} zdjęć; pozostało {remaining}. Możesz wrócić do wysyłania później.',
      resumedNotice: 'Wznawiamy zapisany upload. {confirmed} zdjęć jest już potwierdzonych, do wysłania pozostało {remaining}.',
      faq: {
        offlineQuestion: 'Co jeśli stracę internet?',
        offlineAnswer: 'Wysyłanie poczeka na połączenie i po jego odzyskaniu spróbuje kontynuować. Nie musisz zaczynać całego zestawu od początku.',
        closedQuestion: 'Co jeśli zamknę lub odświeżę stronę?',
        closedAnswer: 'Po powrocie pokażemy niedokończoną sesję. W razie potrzeby wybierzesz ponownie te same pliki lub folder, a zdjęcia już poprawnie zapisane zostaną pominięte.',
        failedQuestion: 'Co jeśli tylko kilka zdjęć ma błąd?',
        failedAnswer: 'Poprawnie wysłane zdjęcia zostają zachowane. Pokażemy dokładnie, ile plików nie przeszło, i pozwolimy wznowić wysyłanie tylko dla nich.',
        laterQuestion: 'Co robi „Wznowię później”?',
        laterAnswer: 'Zapisuje aktualny postęp i pozostawia do wysłania tylko zdjęcia, których system jeszcze nie potwierdził. Możesz wrócić do nich później.',
      },
    },
    upload: {
      confirmedPhotos: 'Potwierdzone zdjęcia',
      transferredData: 'Przesłane dane',
      speed: 'Prędkość wysyłania',
      activeBatches: 'Aktywne paczki',
      pendingPhotos: 'Oczekujące',
      deferredPhotos: 'Odłożone',
      problemPhotos: 'Problematyczne',
      partialFailure: 'Nie udało się wysłać {failed} z {total} zdjęć. {sent} wysłano poprawnie.',
      retryFailed: 'Wyślij ponownie ({count})',
      keepFailedForLater: 'Zostaw na później ({count})',
      actions: {
        pause: 'Wstrzymaj',
        resume: 'Wznów',
        resumeLater: 'Wznowię później',
      },
      status: {
        idle: 'Oczekiwanie na rozpoczęcie wysyłania…',
        preparing: 'Przygotowywanie zdjęć do wysłania…',
        uploading: 'Wysyłanie zdjęć…',
        stalled: 'Brak postępu transferu. Połączenie może być chwilowo przeciążone…',
        waiting: 'Dane wysłane. Oczekiwanie na potwierdzenie serwera…',
        waitingLong: 'Serwer nadal przetwarza paczkę. Wysyłanie nie zostało przerwane…',
        retrying: 'Wykryto chwilowy problem. Wysyłanie będzie automatycznie ponawiane…',
        deferred: 'Część paczek została odłożona. Najpierw wysyłamy pozostałe zdjęcia…',
        offline: 'Brak połączenia z internetem. Wysyłanie wznowi się automatycznie po odzyskaniu połączenia…',
        pausing: 'Wstrzymywanie. Kończymy aktualnie wysyłane paczki…',
        paused: 'Wysyłanie wstrzymane.',
        stopping: 'Kończenie aktywnych paczek i zapisywanie pozostałych zdjęć na później…',
        failed: 'Nie udało się wysłać części zdjęć.',
        completed: 'Wysyłanie zakończone.',
      },
    },
    agreement: 'Umieszczając zdjęcia, akceptujesz regulamin serwisu i licencję',
  },
  common: {
    clear: 'Wyczyść',
    add: 'Dodaj',
    subHeaderTitle: 'RunPixie - znajdź siebie!',
    country: 'Kraj',
    completeData: 'Uzupełnij dane',
    city: 'Miasto',
    selectDate: 'Wybierz datę',
    close: 'Zamknij',
    submit: 'Zatwierdż',
    selectedDate: 'Wybrana data:',
    event: 'Wydarzenie',
    summary: 'Podsumowanie',
    imagesCount: 'Wybrano zdjęć',
    videosCount: 'Wybrano filmów',
    date: 'Data',
    next: 'Dalej',
    return: 'Powrót',
    ups: 'Coś poszło nie tak!',
    turnOnThumbs: 'Włącz miniaturki w podglądzie',
    turnOnThumbsInfo:
      'Włącz tą opcje jeśli chcesz zobaczyć miniaturki w podglądzie (niezalecane przy dodawaniu większej ilości zdjęć)',
    statuteRoute: '/regulamin-korzystania-z-serwisu/',
    checkHere: 'sprawdź tutaj',
    understand: 'Rozumiem',
    save: 'Zapisz',
    edit: 'Edytuj',
    loadingEvents: 'Ładowanie wydarzeń',
    refetchEvents: 'Załaduj wydarzenia ponownie',
    deleted: 'Usunięto',
    added: 'Dodano pomyślnie'
  },
  userPanel: {
    title: 'Panel użytkownika',
    hello: 'Cześć',
    addedPhoto: 'Dodane zdjęcia',
    inSystem: 'W systemie od',
    country: 'Kraj',
    city: 'Miasto',
    gear: 'Bieg',
    emailChanges: 'Email został zmieniony',
    badEmail: 'Wpisz poprawny email',
    walletRequestsTitle: 'Zarejestrowane prośby o wyplaty',
    walletCommissionsTitle: 'Zarejestrowane prowizje',
    blockedMoneyInfo:
      'Wartość Twoich aktualnych zgłoszeń o wypłatę (w blokadzie)',
    noPersonalDataInfo:
      'Aby zgłosić wniosek o wypłatę, uzupełnij swoje dane personalne tj. imię, nazwisko, numer telefonu, adres',
    noWithdrawIntegration:
      'Aby zgłosić wniosek o wypłatę, Twoje konto musi być zintegrowane z partnerem płatności.',
    withdrawMoney: 'Wypłać środki',
    minWithdrawValue: 'Minimalna kwota wypłaty',
    withdraw: 'Wypłać',
    wallet: {
      title: 'Portfel',
      bookingTableTitle: 'Prowizje za zlecenia fotografów',
      bookingReference: 'Zlecenie nr. {bookingId}',
      tableColumns: {
        bookingId: 'ID zlecenia',
        bookingTitle: 'Referencja',
        bookingPrice: 'Cena zlecenia',
      }
    },
    ownCommisionsUnpaid: 'Suma niewypłaconych prowizji',
    ownCommisionsAll: 'Suma wszystkich uzyskanych prowizji',
    albumName: 'Nazwa albumu',
    commission: 'Prowizja',
    status: 'Status',
    sum: 'Kwota',
    yourData: 'Twoje dane',
    phoneNumber: 'tel.',
    paymentInfo:
      'Dane niezbędne do realizacji wypłat - jeśli po zmianie, widzisz dalej stare dane, wyloguj się i zaloguj ponownie.',
    paid: 'Wypłacono',
    tableWalletHint:
      'Poniżej lista albumów z Twoimi zdjęciami które ktoś kupił. Pamiętaj, że kwota uzyskanej prowizji to (a) możliwa premia za najlepsze zdjęcie w pakiecie oraz (b) przypadająca proporcjonalnie według liczby zdjęć kwota prowizji do podziału pomiędzy autorów.',
    tableWalletHintOther:
      'Poniżej lista zarobionych prowizji za sprzedane zdjęcia i albumy. Każdy rząd odpowiada zamówieniu w którym uzyskana została prowizja.',
    tableColumns: {
      album: 'Nr sprzedanego albumu',
      commission: 'Kwota uzyskanej prowizji',
      gear: 'Wydarzenie',
      date: 'Data',
      commissionData: 'Data wypłaty prowizji',
      name: 'Nazwa',
    },
    tableTitle: 'Lista sprzedanych albumów',
    imagesTableTitle: 'Lista Twoich zdjęcia w ramach albumu',
    promptWalletInfo:
      'Wypłacasz prowizję za udzieloną RunPixie licencję na zdjęcia, które zostały wykupione przez biegaczy, zgodnie z',
    promptWalletInfo2:
      'Wypłata zalecana powyżej <strong>20 zł</strong>, wymagana po przekroczeniu <strong>500 zł</strong>. Koszt wypłaty <strong>2,5 zł</strong>. Środki niewypłacone w ciągu 2 lat przepadają',
    regulamin: 'regulaminem serwisu i umową licencyjną',
    accountData: 'Dane użytkownika',
    billingAddress: 'Dane rozliczeniowe',
    userData: {
      name: 'Imie',
      surname: 'Nazwisko',
      nrTelephone: 'Telefon',
      address: 'Adres',
      address2: 'Adres 2',
      state: 'Województwo',
      company: 'Firma',
      country: 'Kraj',
      city: 'Miasto',
      postcode: 'Kod pocztowy',
      email: 'Email',
      role: 'Rola',
      submit: 'Zaktualizuj dane',
    },
    empty: 'Nie uzupełnione',
    completeData:
      'Uzupełnij dane (zostaniesz przekierowany do nowej karty [niezbędne będzie ponowne zalogowanie])',
    editData: 'Edytuj dane',
    solded: 'Sprzedano',
    withdrawNotConnectedInfo:
      'Brak połączenia z zewnętrzną platformą płatniczą',
    connectHereLabel: 'Połącz tutaj',
    billingDataUpdating: 'Akutalizowanie...',
    registerPhotographer: "Zarejestruj fotografa",
    registerPhotographerTitle: "Użyj formularza aby zarejestrować fotografów współpracujących z Tobą.",
    accountVerificationTitle: "Weryfikacja konta",
    accountVerificationInfo: "Zweryfikujemy ich dane, a następnie założymy im konto i poinformujemy mailowo o potrzebie wygenerowania hasła w celu dostępu do aplikacji.",
    shareConsentTitle: "Zgoda na udostępnianie",
    shareConsentInfo: "Upewnij się, że masz ich pozwolenie na udostępnianie ich danych. Jeżeli zgłoszą nam sprzeciw będziemy zmuszeni usunąć ich konto i skontaktujemy się z Tobą.",
    integration: {
      title: 'Integracja wypłat',
      bankAccountIban: 'Number IBAN',
      bankAccountCurrency: 'Waluta konta bankowego',
      language: 'Język',
      submit: 'Załóż/Zsynchronizuj konto Useme',
      taxId: 'Pesel/Nr Podatkowy',
      userExists:
        'Konto z podanym emailem istnieje na portalu Useme. Integracja zakończona sukcesem, możesz zalogować się ponownie.',
      integrationValidation:
        'Wprowadzono błędne dane, upewnij się że dane dane typu Pesel i Iban są poprawne. Jeżeli masz już konto na Useme upewnij się że podane dane są identyczne.',
      editInformation:
        'Jeżeli w przyszłości będziesz chciał/a zmienić swoje dane, możesz to zrobić po zalogowaniu na oficjalnej stronie partnera https://useme.com',
      informationTitle: 'Informacje dotyczące integracji z Useme',
      description:
        'Aby zarabiać na swoich fotografiach, musisz mieć konto w Useme. Useme to zewnętrzna platforma do obsługi płatności, który ułatwia nam wypłatę środków, a Tobie ich odbiór. Rejestracja jest bezpłatna i prosta.',
      registerWays: 'Możesz zarejestrować się w Useme na 2 sposoby:',
      recommendedOption: 'Zalecana opcja',
      optionTwo:
        'Jeśli zdecydujesz się zarejestrować przez oficjalną stronę Useme, musisz wrócić i użyć tych samych danych w naszym formularzu, aby dokończyć integrację. Pamiętaj dane muszą być identyczne z tymi na Twoim profilu w Useme.',
      optionOne:
        'Jeśli zdecydujesz się zarejestrować przez nasz formularz, po pomyślnej rejestracji, będziesz mógł uzyskać początkowe hasło wysyłając link do resetu hasła ',
      optionOneAdditional:
        'Następnie możesz użyć tego hasła do zalogowania się do swojego konta Useme i zmienić dane według uznania.',
      important: 'Ważne',
      termsAcceptance:
        'Rejestrując się w Useme, akceptujesz ich warunki korzystania.',
      moreInfo: 'Więcej informacji znajdziesz pod linkiem',
      successTitle: 'Integracja wypłat z Useme zakończona pomyślnie!',
      successMessage: 'Twoje konto Useme zostało pomyślnie zintegrowane.',
      emailLabel: 'E-mail konta Useme:',
      approvalMessage:
        'Po zatwierdzeniu przez nasz zespół jako profesjonalny fotograf, będziesz gotowy do zarabiania na swoich zdjęciach.',
      payoutDetails:
        'Pamiętaj, że jeśli chcesz zmienić jakiekolwiek szczegóły dotyczące wypłat, możesz to zrobić za pośrednictwem portalu Useme dostępnego po zalogowaniu na',
      resetPasswordMessage:
        'Jeśli podczas integracji utworzyliśmy dla Ciebie konto w Useme, możesz zalogować się do ich portalu i zresetować hasło',
      resetPasswordLink: 'tutaj.',
      officialSite: 'oficjalnej stronie',
    },
    settings: {
      title: 'Ustawienia fotografa',
      photoSalesTitle: 'Globalne ustawienia sprzedaży zdjęć',
      disableBulkSale: 'Wyłącz sprzedaż hurtową moich zdjęć',
      bulkSaleDescription: 'W tej sekcji ustalasz globalne preferencje sprzedaży hurtowej. Mają one zastosowanie jako wartość domyślna dla nowo wgrywanych zdjęć. Jeśli dany bieg nie ma określonych ustawień w momencie wgrywania zdjęć, przypiszemy mu te globalne ustawienia. (będziesz mógł je zmienić)',
      description: 'W tej sekcji możesz wybrać konkretne wydarzenia, dla których chcesz wyłączyć sprzedaż hurtową i włączyć sprzedaż zdjęć indywidualnie. Po wgraniu pierwszego zdjęcia do wydarzenia, jeśli nie miało ono ustawień, automatycznie przypisane zostaną ustawienia globalne.',
      settingsLocked: 'Ustawienia zablokowane',
      settingsLockedInfo: 'Sprzedaż hurtową można wyłączyć tylko przed wgraniem pierwszego zdjęcia do wydarzenia (gdy włączona jest globalna sprzedaż hurtowa). Jeśli wgrano już zdjęcia, nie możesz wyłączyć sprzedaży hurtowej, masz jednak jednorazową możliwość jej przywrócenia. W przypadku wyłączonej sprzedaży hurtowej, możesz dowolnie zmieniać cenę pojedynczego zdjęcia niezależnie od daty wydarzenia.',
      bulkSaleDisabled: 'Sprzedaż hurtowa: Wyłączona',
      bulkSaleEnabled: 'Sprzedaż hurtowa: Włączona',
      singlePhotoPrice: 'Cena pojedyńczego zdjęcia w zł',
      singlePhotoPriceDynamic: 'Cena pojedyńczego zdjęcia {price}zł',
      error: 'Bład przy zapisie ustawień sprzedaży zdjęć',
      success: 'Ustawienia zapisane pomyślnie',
      aboutPhotographerTitle: 'Ustawienia personalizowanej strony fotografa',
      aboutPhotographerInfo: 'Uzupełnij te pola, by spersonalizować swój publiczny landing page.',
      landingHeadline: 'Nagłówek powitalny',
      landingBio: 'Krótkie "O mnie"',
      landingInstagram: 'Link do Instagrama',
      landingRegion: 'Rejon przyjmujesz zlecenia?',
      openForBookings: 'Dostępny do przyjmowania zleceń?',
      acceptingBookings: 'Przyjmuję zlecenia',
      notAcceptingBookings: 'Nie przyjmuję zleceń',
      saveAndCreateLanding: 'Zapisz i stwórz moją stronę fotografa'
    }
  },
  status: {
    waiting: 'Oczekujące',
    rejected: 'Odrzucone',
    completed: 'Zrealizowane',
  },
  error: {
    badAuth: 'Błąd autoryzacji.',
    badAuthToken: 'Błąd autoryzacji - zaloguj się ponownie.',
    badAuthPriviliges: 'Błąd autoryzacji - potrzebujesz wyższych uprawnień.',
    badAuthTokenProblem: 'Błąd autoryzacji - problem z tokenem.',
    route: 'Brak dostępu.',
    walletNoAmmount: 'Brak pól kwoty, autora lub balansu konta.',
    code: 'Coś poszło nie tak z kodem.',
    imageFail: 'Houston, mamy problem z funkcją przesyłania obrazu.',
    usernameRequired: 'Pole nazwy użytkownika jest wymagane.',
    usernameExists: 'Użytkownik z wybraną nazwą już istnieje.',
    emailRequired: 'Pole e-mail jest wymagane.',
    phoneNumber: 'Pole numer telefonu jest wymagane',
    phoneNumberExists: 'Numer telefonu jest już w użyciu.',
    passwordRequired: 'Pole hasła jest wymagane.',
    invalidCredentials: 'Nieprawidłowa nazwa użytkownika lub hasło.',
    emailExists: 'E-mail już istnieje, spróbuj zresetować hasło.',
    addedImagesInfo: 'dodanych zdjęć:',
    addedVideosInfo: 'dodanych filmów:',
    renewSendImages: 'Wznów wysyłanie zdjęć',
    renewSendVideos: 'Wznów wysyłanie filmów',
    sendLater: 'Zamknij, wyślę później',
    sendLaterInfo:
      'Zdjęcia z kroku pierwszego zostały zaktualizowane, pozostały tylko te które nie zostały wgrane',
    catchedError: 'Wystąpił błąd',
    registerWithdrawError: 'Wystąpił błąd w rejestracji z parterem płatności',
    errorBillingForm: 'Błąd w akutalizacji danych, sprawdź wszystkie pola',
    fetchEvents:
      'Wystąpił błąd przy pobieraniu listy wydarzeń. Spróbuj później.',
    noDashboardData: 'Nie wystarczająca ilość danych. Spróbuj później.',
    invalidEvent: 'To wydarzenie nie istnieje, lub nie masz do niego dostępu',
    eventUnverified:
      'To wydarzenie nie zostało jeszcze zweryfikowane przez administratora',
    uploadsRestriction:
      'Z powodu dużego obciążenia serwera, tylko profesjonalni fotografowie mogą aktualnie dodawać zdjęcia. Spróbuj później.',
    network: 'Przepraszamy, wystąpił problem sieciowy, spróbuj za jakiś czas..',
    server:
      'Nieprawidłowa odpowiedź serwera. Przepraszamy, spróbuj ponownie, jeśli się nie uda, wróć za jakiś czas.',
    bookings: {
      invalidDate: 'Data zlecenia musi być w przyszłości.',
    },
    integration: 'Wystąpił błąd podczas integracji, spróbuj ponownie ponownie później.',
    organizer: {
      photographer: {
        usernameExists: 'Nazwa użytkownika już istnieje.',
        emailExists: 'Email już istnieje.',
        portfolioInvalid: 'Link do portfolio jest nieprawidłowy.',
        generic: 'Błąd podczas rejestracji fotografa. Spróbuj ponownie.'
      }
    }
  },
  success: {
    registeredWithReq: 'Prośba o wypłatę została zarejestrowana, dziękujemy.',
    imageAdded: 'Wszystko dobrze. Zdjęcia dodane, dziękujemy!',
    videoAdded: 'Wszystko dobrze. Filmy dodane, dziękujemy!',
    accountHasBeenCreated: 'Konto zostało założone poprawnie!',
    accountHasBeenCreatedPhotographerVerify:
      'Konto zostało założone poprawnie! Typ Twojego konta jest weryfikowany.',
    billingDataUpdated: 'Dane zaktualizowane!',
    integration: 'Integracja zakończona pomyślnie.',
    registerPhotographer: 'Fotograf został zarejestrowany pomyślnie!'
  },
  languages: {
    polish: 'Polski',
    english: 'Angielski',
  },
  bookings: {
    today: "Dziś",
    myBookings: 'Moje zlecenia',
    goToPhotographers: 'Przejdź do fotografów',
    viewPhotographers: 'Lista zweryfikowanych fotografów',
    photographers: 'Fotografowie',
    goToBookings: 'Przejdź do zleceń',
    loading: 'Ładowanie rezerwacji...',
    noActiveBookings: 'Nie masz jeszcze żadnych aktywnych zleceń.',
    bookingWith: 'Zlecenie dla:',
    bookingDate: 'Data zlecenia',
    createdAt: 'Utworzono',
    region: 'Region',
    book: "Zarezerwuj",
    viewProfile: "Zobacz profil",
    statusLabel: 'Status',
    rateLabel: 'Stawka',
    detailsMessage: 'Szczegóły / Wiadomość',
    noAdditionalMessage: 'Brak dodatkowej wiadomości.',
    loadError: 'Błąd ładowania listy zleceń.',
    photographersLoadError: 'Błąd ładowania listy fotografów.',
    noPhotographersAvailable: 'Żaden fotograf nie jest obecnie otwarty na rezerwacje.',
    status: {
      all: 'Wszystkie',
      completed: 'Zrealizowane',
      pending: 'Oczekujące',
      accepted: 'Zaakceptowane',
      rejected: 'Odrzucone',
      cancelled: 'Anulowane',
      unknown: 'Nieznany'
    },
    store: {
      error: 'Wystąpił błąd przy wysyłaniu zapytania zlecenia.',
      success: 'Oferta zlecenia wysłana!',
    },
    dialog: {
      cancel: {
        title: 'Potwierdź anulowanie',
        message: 'Czy na pewno chcesz anulować zlecenie z {name} w dniu {date}?',
        action: 'Anuluj',
        buttonYes: 'Anuluj zlecenie',
        buttonNo: 'Wróć',
        success: 'Zlecenie zostało pomyślnie anulowane.',
        error: 'Wystąpił błąd podczas anulowania zlecenia.',
      },
      accept: {
        title: 'Potwierdź akceptację',
        message: 'Czy na pewno chcesz zaakceptować zlecenie od {name} na dzień {date}?',
        action: 'Akceptuj',
        buttonYes: 'Akceptuj zlecenie',
        buttonNo: 'Wróć',
        success: 'Zlecenie zostało pomyślnie zaakceptowane.',
        error: 'Wystąpił błąd podczas aktualizacji statusu zlecenia.',
      },
      reject: {
        title: 'Potwierdź odrzucenie',
        message: 'Czy na pewno chcesz odrzucić zlecenie od {name} na dzień {date}?',
        action: 'Odrzuć',
        buttonYes: 'Odrzuć zlecenie',
        buttonNo: 'Wróć',
        success: 'Zlecenie zostało pomyślnie odrzucone.',
        error: 'Wystąpił błąd podczas odrzucania zlecenia.',
      },
      complete: {
        title: 'Potwierdź realizację',
        message: 'Czy na pewno chcesz oznaczyć zlecenie z jako zrealizowane? Przelejemy środki z Twojego portfela, na konto fotografa.',
        action: 'Oznacz jako zrealizowane',
        buttonYes: 'Oznacz jako zrealizowane i opłać',
        buttonNo: 'Wróć',
        success: 'Zlecenie zostało oznaczone jako zrealizowane.',
        error: 'Wystąpił błąd podczas oznaczania zlecenia jako zrealizowanego.',
      }
    },
    fromOrganizer: 'Zlecenie od:',
    goToCalendar: 'Przejdź do kalendarza',
    filterBy: "Wybrany Status",
    currencySupportedLimitations: "Obecnie wspieramy zlecenia tylko w walucie PLN.",
    rateChangeHint: "Stawka jest ustalona w momencie rezerwacji, jeżeli potrzebujesz ją zmienić, anuluj zlecenie a następnie utwórz nowe.",
    available: 'Dostępny',
    payout: {
      invalidStatus: 'Niepoprawny status',
      unathorized: 'Brak autoryzacji do przeprocesowania',
      success: 'Zlecenie opłacone pomyślnie',
      wpError: 'Błąd realizacji po stronie systemu prowizji. Spróbuj ponownie później lub skontaktuj się z administratorem.',
      error: 'Wystąpił błąd. Spróbuj ponownie później.',
      unexpected: 'Nieoczekiwany błąd. Spróbuj ponownie później.'
    },
    eventsTitle: 'Wydarzenia',
    bookingsTitle: 'Zlecenia',
    eventOrganizer: 'Organizator',
    insufficientFunds: 'Brak wystarczających środków.'
  }
};
